import { BaseMyopMessage } from "./BaseMessage";

// sent by host to components, contains thier id 
export class InitMessage extends BaseMyopMessage<{ id: string }> {
    messageType = 'InitMessage';

    constructor(id: string) {
        super()
        this.content = { id }
    }

    isTypeof(msg: BaseMyopMessage): boolean {
        return msg.messageType === this.messageType
    }
}

// component notify host the it was initated 
export class InitResponse extends InitMessage {
    messageType = 'InitResponse';
}

// component ask to host to get initated 
export class InitRequest extends BaseMyopMessage {
    messageType = 'InitRequest';
}
